import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Status from "../../../../request-dashboard/request/status/status";
import { MUITable } from "../../../../../common/components";
import StatusFilter from "../../../../../common/components/status-filter/status-filter";
import Department from "../../../../departments/departments";
import addREC from "../../../../../assets/icons/addREC.svg";
import editIcons from "../../../../../assets/icons/editIcons.svg";
import deleteRedIcons from "../../../../../assets/icons/delete-red.svg";
import CompanyDashboardInitiativeDrawerAddMilestones from "./company-dashboard-initiative-drawer-add-milestones/company-dashboard-initiative-drawer-add-milestones";
import DeleteConfirmationPopup from "../../../../../common/components/delete-confirmation-popup/delete-confirmation-popup";
import {
  getAllMilestones,
  deleteMilestonesByID,
  getMilestoneDepartmentsForInitiative,
} from "../../../../../api/milestones";
import "./company-dashboard-initiative-drawer-milestones.scss";
import { TableHeader } from "../../../../../common/components/mui-table/mui-table";
import MODULES from "../../../../../constants/modules";
import { usePermissions } from "../../../../../common/hooks/usePermissions";
import dayjs from "dayjs";
import { Tooltip, IconButton  } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import infoIcon from "../../../../../assets/icons/warning_icon.svg";
import CompanyDashboardInitiativeDrawerViewClearedMilestones from "./company-dashboard-initiative-drawer-view-cleared-milestone/company-dashboard-initiative-drawer-view-cleared-milestone";

const headers: TableHeader[] = [
  { key: "milestone", label: "Title" },
  { key: "department", label: "Department", filterable: true },
  { key: "date", label: "Date" },
  { key: "status", label: "Status" },
];

const getInitiativeDurationText = (duration: number): string => {
  if (duration < 1) return "This initiative is under 1 month.";
  const floorValue = Math.floor(duration);
  const unit = floorValue === 1 ? "month" : "months";
  return duration % 1 === 0
    ? `This initiative runs for ${duration} ${unit}.`
    : `This initiative exceeds ${floorValue} ${unit}.`;
};

const FADED_SKIP_KEYS = new Set(["isFaded", "id", "milestone"]);
const CLEARED_FADED_SKIP_KEYS = new Set(["isFaded"]);

const wrapWithFadedTooltip = (row: { [key: string]: any }, skipKeys: Set<string>) => {
  Object.keys(row).forEach((key) => {
    if (skipKeys.has(key)) return;
    row[key] = (
      <Tooltip
        title="This milestone is inactive as its department is no longer participating."
        placement="top"
      >
        <span style={{ display: "inline-block", width: "100%", pointerEvents: "auto" }}>
          {row[key]}
        </span>
      </Tooltip>
    );
  });
  row._rowClass = "faded-row";
};
const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
userDetails?.roles?.find((role: any) => role?.name === "Admin");

const getColumnIsAchieved = () => {
    if(userDetails?.roles?.find((role: any) => role?.name === "Admin" || role?.name === "ELT")){
      return true;
    }else {
      return false;
    }
};


const getIsAchieved = (item: any) => {
  if(item?.statusResponse?.statusName === "Achieved"){
    if(userDetails?.roles?.find((role: any) => role?.name === "Admin" || role?.name === "ELT")){
      return  false
    }else {
      return true;
    }
  }
  return false;
};
const mapMilestoneToRow = (item: any): { [key: string]: any } => {
  const isFaded = item?.isDisable || false;
  const row: { [key: string]: any } = {
    id: item?.milestoneId,
    milestone: item?.milestoneTitle,
    department: (
      <Department
        key={item?.departmentResponse?.departmentId}
        departmentId={item?.departmentResponse?.departmentId}
        departmentName={item?.departmentResponse?.departmentName || "-"}
      />
    ),
    date: item?.endDate ? dayjs(item.endDate).format("MM-DD-YYYY") : "-",
    status: (
      <Status
        status={item?.statusResponse?.statusName}
        isDisabled={item?.isApprovalPending}
      />
    ),
    isAchieved: getIsAchieved(item),
    data: item,
    isFaded,
  };
  if (isFaded) {
    wrapWithFadedTooltip(row, FADED_SKIP_KEYS);
  }
  return row;
};

const mapClearedMilestoneToRow = (item: any): { [key: string]: any } => {
  const isFaded = item?.isDisable || false;
  const row: { [key: string]: any } = {
    id: item?.milestoneId,
    milestone: item?.milestoneTitle,
    department: (
      <Department
        key={item?.departmentId}
        departmentId={item?.departmentId}
        departmentName={item?.departmentName || "-"}
      />
    ),
    date: item?.endDate ? dayjs(item.endDate).format("MM-DD-YYYY") : "-",
    status: (
      <Status
        status={item?.statusResponse?.statusName || "Achieved"}
        isDisabled={item?.isApprovalPending}
      />
    ),
    data: item,
    isFaded,
  };
  if (isFaded) {
    wrapWithFadedTooltip(row, CLEARED_FADED_SKIP_KEYS);
  }
  return row;
};

const CompanyDashboardInitiativeMilestones: any = (props: any) => {
  const {
    onRowClick,
    employeesList,
    setLoading,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    initiativeId,
    fetchInitiativeById,
    fetchInitiatives,
    keyResultId,
    objectiveId,
    initiativeAPIData,
    departmentsList,
    milestonesData,
    setMilestonesData,
    initiativeDataPermissions,
    fetchUpcomingMilestones,
  } = props;
  const [isOpenAddPopup, setIsOpenAddPopup] = useState(false);
  const [selectedMenuOption, setSelectedMenuOption] = useState(null);
  const [addPopupTitle, setAddPopupTitle] = useState("");
  const [isDeletePopupOpen, setDeletePopupOpen] = useState(false);
  const [deletePopupId, setDeletePopupId] = useState<number | null>(null);
  const [editData, setEditData] = useState<any>(null);
  const [isOpenViewPopup, setIsOpenViewPopup] = useState(false);
  const [milestoneDepartments, setMilestoneDepartments] = useState<any[]>([]);
  const [defaultSelectedFilters, setDefaultSelectedFilters] = useState<any>({
    status: [{ key: "Created", value: "Created" },
      { key: "Missed", value: "Missed" }],
  });
  const {
    canRead: canReadMilestones,
    canWrite: canWriteMilestones,
    canEdit: canEditMilestones,
    canDelete: canDeleteMilestones,
  } = usePermissions(MODULES.MILESTONE);
  const filterIconRefs = React.useRef<Record<string, HTMLElement | null>>({});

  const [openFilter, setOpenFilter] = React.useState<string | null>(null);

  const filters = {
    status: [
      { key: "All", value: "All" },
      { key: "Achieved", value: "Achieved" },
      { key: "Created", value: "Created" },
      { key: "Missed", value: "Missed" },
    ],
  };

  const [selectedFilters, setSelectedFilters] = React.useState<any>({
    status: [],
  });

  const handleFilterSelect = (filterKey: string, opt: any) => {
    setSelectedFilters((prev: any) => {
      
      const curr = [...prev[filterKey], ...(defaultSelectedFilters?.status || [])];
      const exists = curr.some((x: any) => x.key === opt.key);
      const updatedStatus = exists ? curr.filter((x: any) => x.key !== opt.key).filter((x: any) => x.key !== "All") : [...curr, opt];
      const isAchievedSelected = updatedStatus.some((s: any) => s.key === "Achieved");
      const isMissedSelected = updatedStatus.some((s: any) => s.key === "Missed");
      const isCreatedSelected = updatedStatus.some((s: any) => s.key === "Created");
      
      if(opt.key === "All" && !exists) {
        return {
          ...prev,
          [filterKey]: filters?.status
        }
      }

      if(opt.key === "All" && exists) {
        return {
          ...prev,
          [filterKey]: []
        }
      }

      if (isAchievedSelected && isMissedSelected && isCreatedSelected && updatedStatus.length === 3) {
        return {
          ...prev,
          [filterKey]: [...updatedStatus, { key: "All", value: "All" } ]
        }
      }

      
      return {
        ...prev,
        [filterKey]: updatedStatus,
      };
    });
    setDefaultSelectedFilters({
      status: [],
    });
  };

  const fetchAllMilestones = async () => {
    setLoading(true);
    try {
      const response = await getAllMilestones({ initiativeId, statusNames: selectedFilters.status?.length ? selectedFilters.status?.map((s: any) => s.value)?.filter((v: any) => v !== "All") : defaultSelectedFilters.status?.map((s: any) => s.value) || [] });
      if (response?.data?.data?.length > 0) {
        const activeMilestones = response.data.data || [];
        
        setMilestonesData(activeMilestones.map(mapMilestoneToRow));
        setAlertMessage("Milestones fetched successfully");
        setAlertType("success");
      } else {
        setMilestonesData([]);
      }
      setAlertOpen(true);
      setDeletePopupId(null);
      setLoading(false);
    } catch (error: any) {
      if (error?.response?.status === 404) {
        setMilestonesData([]);
      } else {
        setAlertMessage("Failed to fetch disposition");
      }
      setAlertType("error");
      setAlertOpen(true);
      setDeletePopupId(null);
      setLoading(false);
    }
  };

  const handleCloseViewPopup = () => setIsOpenViewPopup(false);

  const fetchMilestoneDepartments = async (initiativeId: number) => {
    try {
      const response = await getMilestoneDepartmentsForInitiative(initiativeId);
      const transformedDepartmentsList =
        response.data.data?.map((dept: any) => ({
          key: dept.pk || dept.key, // Support both pk (from API) and key (existing format)
          value: dept.departmentName || dept.value, // Support both departmentName (from API) and value (existing format)
        })) || [];
      setMilestoneDepartments(transformedDepartmentsList);
    } catch (err) {
      console.error("Failed to fetch milestone departments", err);
    }
  };

  // Filter out departments that ONLY have cleared milestones (no active milestones)
  const getActiveDepartments = () => {
    // Get department IDs from active milestones
    const activeDepartmentIds = new Set(
      milestonesData.map(
        (milestone: any) => milestone?.data?.departmentResponse?.departmentId,
      ),
    );

    // Only show departments that have at least one active milestone
    return milestoneDepartments.filter((dept: any) =>
      activeDepartmentIds.has(dept.key),
    );
  };

  useEffect(() => {
    if (initiativeId) {
      fetchMilestoneDepartments(initiativeId);
      fetchAllMilestones();
    }
  }, [initiativeId, selectedFilters ]);

  const handleOpenAddPopup = () => {
    setAddPopupTitle("Add Milestone");
    setIsOpenAddPopup(true);
  };

  const handleCloseAddPopup = () => {
    setIsOpenAddPopup(false);
    setEditData(null);
    setAddPopupTitle("");
  };

  const handleOpenEditPopup = (data: any) => {
    setIsOpenAddPopup(true);
    setEditData(data);
    setAddPopupTitle("Edit Milestone");
    setSelectedMenuOption(null);
    setDeletePopupId(null);
  };

  const handleOpenDeletePopup = (handleClose: () => void, data: any) => {
    setDeletePopupOpen(!isDeletePopupOpen);
    setDeletePopupId(data?.id);
    handleClose();
  };

  const deleteMilestone = async () => {
    setLoading(true);
    try {
      await deleteMilestonesByID(deletePopupId);
      fetchInitiativeById();
      fetchAllMilestones();
      fetchMilestoneDepartments(initiativeId);
      setAlertMessage("Milestone deleted successfully");
      setAlertType("success");
      setAlertOpen(true);
      setDeletePopupOpen(false);
      setLoading(false);
      setDeletePopupId(null);
    } catch (error) {
      console.error("Failed to delete milestone", error);
      setAlertMessage("Failed to delete Milestone");
      setAlertType("error");
      setAlertOpen(true);
      setDeletePopupOpen(false);
      setDeletePopupId(null);
      setLoading(false);
    }
  };

  if (!canReadMilestones) {
    return null;
  }

  const milestoneCount = initiativeAPIData?.minMileStonesRequired || 0;
  const milestoneLabel = milestoneCount === 1 ? "milestone is" : "milestones are";
  const showMilestonesRequiredInfo =
    initiativeId &&
    initiativeAPIData &&
    initiativeAPIData?.milestones?.length < milestoneCount;

  const milestonesRequiredInfo = showMilestonesRequiredInfo ? (
    <div className="company-dashboard-initiative-drawer-milestones-info">
      <img src={infoIcon} alt="info" />
      <div className="info-text">
        <span>{getInitiativeDurationText(initiativeAPIData.durationOfInitiative || 0)}</span>
        <span>At least {milestoneCount} {milestoneLabel} required.</span>
      </div>
    </div>
  ) : null;

  const viewClearedButton = 
    <div style={{ display: "flex", alignItems: "center", marginRight: 10 }}>
        <IconButton
          ref={(el) => {
            filterIconRefs.current["status"] = el;
          }}
          sx={{
            bgcolor: selectedFilters.status?.length > 0 ? "#5b5a84" : "#ffffff",
            height: 30,
            width: 30,
            "&:hover": { bgcolor: "#4a4970", color: "#ffffff" },
          }}
          onClick={() => setOpenFilter((p) => (p === "status" ? null : "status"))}
        >
          <FilterAltOutlinedIcon sx={{ color: selectedFilters.status?.length > 0 ? "#ffffff" : "#4a4970", "&:hover": { color: "#ffffff" }}}  />
        </IconButton>
      <StatusFilter
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        filterIconRefs={filterIconRefs}
        filters={filters}
        selectedFilters={selectedFilters?.status?.length > 0 ? selectedFilters : defaultSelectedFilters}
        handleFilterSelect={handleFilterSelect}
      />
    </div>

  const addMilestoneButton = initiativeId ? (
    <button style={{ border: "none", background: "none", padding: 0 }} onClick={handleOpenAddPopup}>
      <img
        src={addREC}
        alt="add"
        className="company-dashboard-initiative-drawer-milestones-header-actions-add"
        style={{ cursor: "pointer", opacity: 1 }}
      />
    </button>
  ) : (
    <Tooltip title="Please create an Initiative first to add Milestone">
      <span style={{ display: "inline-block", pointerEvents: "auto" }}>
        <img
          src={addREC}
          alt="add"
          className="company-dashboard-initiative-drawer-milestones-header-actions-add"
          style={{ cursor: "not-allowed", opacity: 0.5, pointerEvents: "none" }}
        />
      </span>
    </Tooltip>
  );

  const showActionsColumn =
    (canEditMilestones || canDeleteMilestones) && initiativeDataPermissions;

  const tableMenuOptions: any[] = [];
  if (canEditMilestones && (initiativeDataPermissions || getColumnIsAchieved())) {
    tableMenuOptions.push({
      label: <div>Edit</div>,
      onClick: (handleMenuClose: any, row: any) => {
        handleMenuClose();
        handleOpenEditPopup(row);
      },
      icon: editIcons,
    });
  }
  if (canDeleteMilestones && (initiativeDataPermissions || getColumnIsAchieved())) {
    tableMenuOptions.push({
      label: <div style={{ marginLeft: "5px" }}>Delete</div>,
      onClick: (handleMenuClose: any, row: any) =>
        handleOpenDeletePopup(handleMenuClose, row),
      icon: deleteRedIcons,
    });
  }

  return (
    <div
      className="company-dashboard-initiative-drawer-milestones"
      style={{ height: milestonesData.length > 6 ? "96%" : "auto" }}
    >
      <div className="company-dashboard-initiative-drawer-milestones-header">
        <div className="company-dashboard-initiative-drawer-milestones-header-left">
          <div className="milestones-title">Milestones</div>
          {milestonesRequiredInfo}
        </div>
        <div className="company-dashboard-initiative-drawer-milestones-header-actions">
          {viewClearedButton}
          {initiativeDataPermissions && canWriteMilestones && addMilestoneButton}
        </div>
      </div>

      <div className="company-dashboard-initiative-drawer-milestones-content">
          <MUITable
            columnNames={headers}
            rowsData={milestonesData}
            showChatColumn={false}
            onRowClick={onRowClick}
            showActionsColumnWithOptions={showActionsColumn || getColumnIsAchieved()}
            menuOptions={tableMenuOptions}
            selectedMenuOption={selectedMenuOption}
            setSelectedMenuOption={setSelectedMenuOption}
            onFilterChange={() => {}}
            departmentsList={getActiveDepartments()}
            noRecordsTitle="No Milestones available to display."
            isFromMilestone={true}
            noRecordsMessage="Please reload the page, or add a new Milestone."
          />
      </div>
      {isOpenAddPopup ? (
        <CompanyDashboardInitiativeDrawerAddMilestones
          isOpenAddPopup={isOpenAddPopup}
          onCancel={handleCloseAddPopup}
          addPopupTitle={addPopupTitle}
          editData={editData}
          setEditData={setEditData}
          milestonesData={milestonesData}
          setMilestonesData={setMilestonesData}
          employeesList={employeesList}
          setLoading={setLoading}
          setAlertMessage={setAlertMessage}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen}
          initiativeId={initiativeId}
          fetchInitiativeById={fetchInitiativeById}
          fetchInitiatives={fetchInitiatives}
          keyResultId={keyResultId}
          objectiveId={objectiveId}
          initiativeAPIData={initiativeAPIData}
          fetchAllMilestones={fetchAllMilestones}
          departmentsList={departmentsList}
          fetchMilestoneDepartments={fetchMilestoneDepartments}
          fetchUpcomingMilestones={fetchUpcomingMilestones}
        />
      ) : (
        ""
      )}
      {isOpenViewPopup && (
        <CompanyDashboardInitiativeDrawerViewClearedMilestones
          isOpenViewPopup={isOpenViewPopup}
          onCancel={handleCloseViewPopup}
          clearedMilestonesData={() => {}}
          initiativeDataPermissions={initiativeDataPermissions}
          handleDeleteMilestone={deleteMilestone}
          setDeletePopupOpen={setDeletePopupOpen}
          setDeletePopupId={setDeletePopupId}
          isDeletePopupOpen={isDeletePopupOpen}
          deletePopupId={deletePopupId}
          isOpenAddPopup={isOpenAddPopup}
          setIsOpenAddPopup={setIsOpenAddPopup}
          editData={editData}
          setEditData={setEditData}
          addPopupTitle={addPopupTitle}
          setAddPopupTitle={setAddPopupTitle}
          milestonesData={milestonesData}
          setMilestonesData={setMilestonesData}
          employeesList={employeesList}
          setLoading={setLoading}
          setAlertMessage={setAlertMessage}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen}
          initiativeId={initiativeId}
          fetchInitiativeById={fetchInitiativeById}
          fetchInitiatives={fetchInitiatives}
          keyResultId={keyResultId}
          objectiveId={objectiveId}
          initiativeAPIData={initiativeAPIData}
          fetchAllMilestones={fetchAllMilestones}
          departmentsList={departmentsList}
          fetchMilestoneDepartments={fetchMilestoneDepartments}
          fetchUpcomingMilestones={fetchUpcomingMilestones}
        />
      )}
      {isDeletePopupOpen &&
        !isOpenViewPopup &&
        ReactDOM.createPortal(
          <DeleteConfirmationPopup
            isOpen={true}
            onClose={() => setDeletePopupOpen(!isDeletePopupOpen)}
            handleDelete={() => {
              deleteMilestone();
            }}
            deleteId={deletePopupId}
          />,
          document.body,
        )}
    </div>
  );
};

export default CompanyDashboardInitiativeMilestones;
